import Link from 'next/link'

const variants = {
  base: 'px-4 py-2 rounded-lg xs:min-w-[180px] min-h-[50px] transition-colors flex items-center justify-center',
  primary: 'bg-primary text-white hover:bg-primary/80',
  secondary:
    'border-white text-white border hover:border-primary hover:text-primary',
  outline:
    'border-black text-black border hover:border-black/50 hover:text-black/50',
}

export const Button = ({
  children,
  variant,
  link,
  type = 'button',
  disabled = false,
  className,
}: {
  children: React.ReactNode
  variant?: keyof typeof variants
  link?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  className?: string
}) => {
  return (
    <button
      className={`${variants.base} ${variants[variant || 'primary']} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      type={type}
      disabled={disabled}
    >
      {link ? <Link href={link}>{children}</Link> : children}
    </button>
  )
}
